import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Download } from "lucide-react";

import { uploadCustomers } from "src/api/customer";
import { FileDropzone } from "src/components/form";
import { Button } from "src/components/ui/button";
import { usePortalContext } from "src/context/PortalContext";
import { showSuccessToast } from "src/lib/utils";

const BulkCustomerModal = () => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const [file, setFile] = useState<File | null>(null);

	const { mutate, isLoading } = useMutation(uploadCustomers, {
		onSuccess: ({ message }) => {
			showSuccessToast(message ?? "");
			queryClient.invalidateQueries(["customers"]);
			closePortal();
		},
	});

	const handleSubmit = () => {
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);
		mutate(formData);
	};

	return (
		<div className="tw-grid tw-gap-4">
			<FileDropzone
				file={file}
				onFileChange={setFile}
				accept=".xlsx,.xls,.csv"
				hint="Upload a spreadsheet with one customer per row. Use the sample below for the expected columns."
			/>

			<a
				href="./sample-customers.xlsx"
				download
				className="tw-inline-flex tw-w-fit tw-items-center tw-gap-1.5 tw-text-[13px] tw-font-medium tw-text-teal hover:tw-underline"
			>
				<Download className="tw-size-4" />
				Download sample
			</a>

			<Button variant="secondary" type="button" className="tw-w-full" onClick={handleSubmit} disabled={isLoading || !file}>
				{isLoading ? "Uploading..." : "Upload"}
			</Button>
		</div>
	);
};

export default BulkCustomerModal;
